import React from 'react';

import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { styled } from '@mui/material';
import { VIEW_MODE_OPTIONS } from '@common/constants';
// import LoaderButton from '../Button/LoaderButton';
import LoaderButton from '../LoaderButton/LoaderButton';
import { isDetails, isEdit } from '@common/helpers/helpers';

const StyledFooter = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignContent: 'center',
  boxShadow: 4,
  width: '100%',
  position: 'sticky',
}));

const Footer = ({
  viewMode = '',
  onEditClick = () => {},
  onCancel = () => {},
  onSave = () => {},
  isLoading,
  onRightDrawerClose,
  isDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <StyledFooter>
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          alignContent: 'center',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: 1.5,
        }}
      >
        {isDetails(viewMode) && (
          <Button
            data-test-id='sidebar-edit'
            size='small'
            onClick={() => onEditClick(VIEW_MODE_OPTIONS.EDIT)}
            aria-label='search'
            variant='outlined'
            sx={{ mr: 1, ml: 1, flex: 1, width: '100%' }}
            startIcon={<EditIcon />}
          >
            {t(isDetails(viewMode) ? 'edit_button' : 'create_button')}
          </Button>
        )}

        {isEdit(viewMode) && (
          <>
            <Button
              disableFocusRipple
              data-test-id='sidebar-cancel'
              variant='outlined'
              size='small'
              onClick={() => {
                isEdit(viewMode)
                  ? onEditClick(VIEW_MODE_OPTIONS.DETAILS)
                  : onRightDrawerClose();
              }}
              color='error'
              sx={{ ml: 1 }}
              startIcon={<CancelIcon />}
            >
              {t('cancel_button')}
            </Button>

            <LoaderButton
              disableFocusRipple
              size='small'
              isDisabled={isDisabled}
              sizeCircularProgress={15}
              buttonSx={{ mr: 1 }}
              dataTestId='sidebar-save'
              isSubmitting={isLoading}
              onClick={onSave}
            />
          </>
        )}
      </Stack>
    </StyledFooter>
  );
};
export default Footer;
